// Texty ikon hlavičky a otevírací doby (headerTools.js).
export default {
  /** zkratky dnů od neděle (0) — řádky „Po–Pá 7:30–17:00" */
  dayShort: ['Ne', 'Po', 'Út', 'St', 'Čt', 'Pá', 'So'],
  closed: 'Zavřeno',
  login: 'Přihlášení',
  account: 'Můj účet',
  wishlist: 'Oblíbené',
  /** aria-label telefonu v mobilní hlavičce: „Zavolat +420 …" */
  call: (phone) => 'Zavolat ' + phone,
  /** kontakt v hlavičce, řádek pod „Zákaznická podpora": v pracovní době / mimo ni */
  supportUntil: (to) => 'Online do ' + to,
  supportBack: (when, from) => 'Zpět ' + when + ' v ' + from,
  /** totéž celou větou v panelu po najetí */
  supportOnlineLong: (to) => 'Právě online, odpovídáme do\u00A0' + to,
  supportOfflineLong: (when, from) => 'Mimo pracovní dobu, ozveme se ' + when + ' od\u00A0' + from,
  /** kdy podpora zase začne: dnes, zítra, jinak den v týdnu (od neděle) */
  today: 'dnes',
  tomorrow: 'zítra',
  onDay: ['v\u00A0neděli', 'v\u00A0pondělí', 'v\u00A0úterý', 've\u00A0středu', 've\u00A0čtvrtek', 'v\u00A0pátek', 'v\u00A0sobotu'],
  /** den bez podpory v rozpisu panelu („So–Ne –") */
  supportClosed: '–',
  /** e-mail v panelu: pod tlačítkem chatu / bez chatu jako jediný kanál */
  mailLead: 'Nebo napište e-mail',
  mailLeadOnly: 'Napište nám e-mail',
  copy: 'Kopírovat',
  copied: 'Zkopírováno',
};
